import { B } from "../../design/tokens";
import useInView from "../../hooks/useInView";
import useCounter from "../../hooks/useCounter";

function StatItem({ stat, isLast, inView }) {
  const count = useCounter(stat.target, 1800, inView);
  return (
    <div style={{ padding: "72px 40px", borderRight: !isLast ? `1px solid ${B.hairline}` : "none", textAlign: "center", position: "relative" }}>
      <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: "clamp(36px, 4vw, 56px)", fontWeight: 700, lineHeight: 1, color: B.white, marginBottom: 14, letterSpacing: -0.5 }}>
        {stat.prefix}{stat.isStatic ? stat.target : count}{stat.suffix}
      </div>
      <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 11, color: B.faint, letterSpacing: 2.5, textTransform: "uppercase", lineHeight: 1.9, whiteSpace: "pre-line" }}>{stat.label}</div>
    </div>
  );
}

export default function StatsSection() {
  const [ref, inView] = useInView();
  const stats = [
    { target: 8,    suffix: "+", label: "Integrated\nService Areas",          prefix: "", isStatic: false },
    { target: 100,  suffix: "%", label: "Nationwide\nCoverage",               prefix: "", isStatic: false },
    { target: 1,    suffix: "",  label: "One-Stop\nSolution",                 prefix: "", isStatic: true  },
    { target: 1,    suffix: "",  label: "Licensed EnP +\nBroker in One Firm", prefix: "", isStatic: false },
  ];
  return (
    <div ref={ref} style={{ background: `linear-gradient(135deg, ${B.ink} 0%, ${B.navy} 50%, ${B.navyMid} 100%)`, borderBottom: `1px solid ${B.hairline}` }}>
      <div style={{ maxWidth: 1280, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(4,1fr)" }} className="stats-grid">
        {stats.map((s, i) => <StatItem key={i} stat={s} isLast={i === stats.length - 1} inView={inView} />)}
      </div>
    </div>
  );
}
